import comp from "./TableEditor";
export default comp;
